// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Activities-module--wrap--1oSJD","inner":"Activities-module--inner--8az9F","title":"Activities-module--title--2fdcv"};